// Markdown in Tickets und Stories (T-0160): Helfer ohne React.

/**
 * Einfache Zeilenumbrüche erhalten. Markdown fasst Zeilen eines Absatzes
 * zusammen — die bisherigen Meldungen sind aber als Klartext mit Umbrüchen
 * geschrieben und flössen sonst zu einem Block zusammen. Code-Blöcke bleiben,
 * wie sie sind.
 */
export function zeilenumbruecheErhalten(text: string): string {
  let imCode = false;
  return text
    .split('\n')
    .map((zeile, i, zeilen) => {
      if (/^\s*(```|~~~)/.test(zeile)) {
        imCode = !imCode;
        return zeile;
      }
      const naechste = zeilen[i + 1];
      if (imCode || zeile.trim() === '' || naechste === undefined || naechste.trim() === '') return zeile;
      return zeile.endsWith('  ') ? zeile : `${zeile}  `;
    })
    .join('\n');
}

export type Auswahl = { text: string; start: number; ende: number };

/** Die Auswahl mit ``vor`` und ``nach`` umschliessen, z. B. ``**`` für fett. */
export function umschliessen(
  { text, start, ende }: Auswahl,
  vor: string,
  nach = vor,
  platzhalter = 'Text',
): Auswahl {
  const markiert = text.slice(start, ende) || platzhalter;
  const neu = `${text.slice(0, start)}${vor}${markiert}${nach}${text.slice(ende)}`;
  return { text: neu, start: start + vor.length, ende: start + vor.length + markiert.length };
}

/**
 * Jede Zeile der Auswahl mit ``praefix`` beginnen lassen (Liste, Überschrift,
 * Zitat). ``nummeriert`` zählt ``1.``, ``2.``, … hoch.
 */
export function zeilenPraefix({ text, start, ende }: Auswahl, praefix: string, nummeriert = false): Auswahl {
  const anfang = text.lastIndexOf('\n', start - 1) + 1;
  const schluss = text.indexOf('\n', ende);
  const bis = schluss === -1 ? text.length : schluss;
  const block = text
    .slice(anfang, bis)
    .split('\n')
    .map((zeile, i) => `${nummeriert ? `${i + 1}. ` : praefix}${zeile}`)
    .join('\n');
  const neu = `${text.slice(0, anfang)}${block}${text.slice(bis)}`;
  return { text: neu, start: anfang, ende: anfang + block.length };
}

/** Einen Link einsetzen: ``[Auswahl](https://)`` mit markierter Adresse. */
export function linkEinsetzen({ text, start, ende }: Auswahl): Auswahl {
  const beschriftung = text.slice(start, ende) || 'Linktext';
  const adresse = 'https://';
  const neu = `${text.slice(0, start)}[${beschriftung}](${adresse})${text.slice(ende)}`;
  const adressStart = start + beschriftung.length + 3;
  return { text: neu, start: adressStart, ende: adressStart + adresse.length };
}
